<template>
    <div class="form-group">
        <label v-if="label" :for="labelFor" class="form-label">{{label}}</label>
        <input-group :prepend-text="prependText" :prepend-icon="prependIcon" :append-text="appendText" :append-icon="appendIcon">
            <slot :class="{'is-invalid': invalidFeedback}"/>
            <div v-if="invalidFeedback" class="invalid-feedback">{{invalidFeedback}}</div>
        </input-group>
        <small v-if="description" class="form-text text-muted">{{description}}</small>
    </div>
</template>

<script>
    import InputGroup from "./InputGroup";

    export default {
        name: "form-group",
        components: {
            'input-group': InputGroup
        },
        props: {
            label: {
                type: String,
                required: false
            },
            labelFor: {
                type: String,
                required: false
            },
            prependText: {
                type: String,
                required: false
            },
            prependIcon: {
                required: false
            },
            appendText: {
                type: String,
                required: false
            },
            appendIcon: {
                required: false
            },
            description: {
                type: String,
                required: false
            },
            invalidFeedback: {
                type: String,
                required: false
            }
        },
        watch: {
            invalidFeedback(value) {
                if (value) {
                    const input = this.$el.querySelector("input,select,textarea");
                    if (!input){
                        return;
                    }
                    input.classList.add('is-invalid');
                }else{
                    const input = this.$el.querySelector("input,select,textarea");
                    if (!input){
                        return;
                    }
                    input.classList.remove('is-invalid');
                }
            }
        }
    }
</script>